import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_back",
  "use": "icon-icon_back-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-icon_back\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#000\" opacity=\".496\" cx=\"14\" cy=\"14\" r=\"14\" /><g opacity=\".9\"><path d=\"M3 3h22v22H3z\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"m11.836 13.967 6.903 7.037H16.01L9 13.967l7.01-6.96h2.729z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol